__turbopack_context__.v({
  "closeBtn": "DownloadItineraryModal-module__-ulF1G__closeBtn",
  "closeBtnAbsolute": "DownloadItineraryModal-module__-ulF1G__closeBtnAbsolute",
  "errorText": "DownloadItineraryModal-module__-ulF1G__errorText",
  "field": "DownloadItineraryModal-module__-ulF1G__field",
  "fieldLabel": "DownloadItineraryModal-module__-ulF1G__fieldLabel",
  "form": "DownloadItineraryModal-module__-ulF1G__form",
  "header": "DownloadItineraryModal-module__-ulF1G__header",
  "heading": "DownloadItineraryModal-module__-ulF1G__heading",
  "input": "DownloadItineraryModal-module__-ulF1G__input",
  "inputError": "DownloadItineraryModal-module__-ulF1G__inputError",
  "itinerary": "DownloadItineraryModal-module__-ulF1G__itinerary",
  "modal": "DownloadItineraryModal-module__-ulF1G__modal",
  "overlay": "DownloadItineraryModal-module__-ulF1G__overlay",
  "packageInfo": "DownloadItineraryModal-module__-ulF1G__packageInfo",
  "packageRow": "DownloadItineraryModal-module__-ulF1G__packageRow",
  "root": "DownloadItineraryModal-module__-ulF1G__root",
  "slab": "DownloadItineraryModal-module__-ulF1G__slab",
  "submitBtn": "DownloadItineraryModal-module__-ulF1G__submitBtn",
  "success": "DownloadItineraryModal-module__-ulF1G__success",
  "successIcon": "DownloadItineraryModal-module__-ulF1G__successIcon",
  "successMessage": "DownloadItineraryModal-module__-ulF1G__successMessage",
  "successTitle": "DownloadItineraryModal-module__-ulF1G__successTitle",
  "thumb": "DownloadItineraryModal-module__-ulF1G__thumb",
  "title": "DownloadItineraryModal-module__-ulF1G__title",
});
